var map = {
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./login-mall.svg": "xzZT",
	"./manage-booster.svg": "ihJY",
	"./manage-info.svg": "defQ",
	"./manage-password.svg": "N1TS",
	"./manage-temp.svg": "AK6v",
	"./manage.svg": "CJyk",
	"./marker.svg": "0+/s",
	"./order-delete.svg": "Z/c5",
	"./order-exception.svg": "Keap",
	"./order-remit.svg": "qXfb",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order-settle.svg": "kn2v",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-brand.svg": "JTBo",
	"./product.svg": "UHi4",
	"./sms-ad.svg": "2epx",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./staff.svg": "yyF4",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./view.svg": "zjNx",
	"./view_off.svg": "R3oF",
	"./新品.svg": "ECkn",
	"./紧急.svg": "s8AR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 20